import React, { type ReactNode } from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import type { Deployment, DeploymentState } from '../../../../../common/types';
import {
	getMostMeaningfulDeployment,
	getColorForDeploymentState,
} from '../../../../../common/utils/deployments';
import messages from './messages';
import { countEnvironments } from './utils';

type Props = {
	sortedDeployments: Deployment[];
};

export const EnvironmentsLabel = ({ sortedDeployments }: Props) => {
	const { formatMessage } = useIntl();
	const deployment = getMostMeaningfulDeployment(sortedDeployments);
	const otherEnvironmentsCount = countEnvironments(sortedDeployments) - 1;

	return (
		<Container deploymentState={deployment.state}>
			{deployment.environment.displayName}
			{otherEnvironmentsCount > 0 &&
				` ${formatMessage(messages.otherEnvironments, { otherEnvironmentsCount })}`}
		</Container>
	);
};

type ContainerProps = {
	deploymentState: DeploymentState;
	children: ReactNode;
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Container = styled.div<ContainerProps>({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: ({ deploymentState }) => getColorForDeploymentState(deploymentState),
	font: token('font.body.UNSAFE_small'),
	width: '100%',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	whiteSpace: 'nowrap',
});

export default EnvironmentsLabel;
